module.exports = __webpack_public_path__ + "static/media/dropdown-icon.fc18d68c.svg";